export const OTHER_ACCOUNT_ID = 'OTHER'

export const FIELDS_EXISTING = ['amount', 'method', 'name', 'last_name', 'cashout_account_id', 'password', `bank_id`]
export const FIELDS_NEW = ['amount', 'method', 'name', 'last_name',  'bank_statement', 'csf', 'password', 'bank', 'bank_code', 'account']

export const getRequiredFields = ({
  defaultCashoutAccountId,
  selectedCashoutAccountId,
}) => {
  const hasDefault = defaultCashoutAccountId != null && defaultCashoutAccountId !== ''
  const wantsOther = String(selectedCashoutAccountId ?? '') === OTHER_ACCOUNT_ID
  return hasDefault && !wantsOther ? FIELDS_EXISTING : FIELDS_NEW
}
